import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  ClosePurchaseOrderAPi,
  GetAllPurchaseByCompStorID,
  // GetAllStores,
  PrintPurchaseOrderApi,
  // TransferPurchaseOrderAPi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../../components/ToastMesg";
// import PopupSelectField from "../../components/PopupSelectField";
import DataGrid from "../../components/DataGrid";

const Purchase = () => {
  const navigate = useNavigate();
  const { storeG, companyG, userPermID } = useStateContext();
  const [AllOrders, setAllOrders] = useState("");
  const [order, setOrder] = useState(null);
  // const [storeOptions, setStoreOptions] = useState([]);
  // const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const PartGridactiveStatus = (props) => (
    <div className="flex gap-2 justify-center items-center text-white font-bold">
      <label
        className={`py-2 px-2 rounded-2xl ${props.po_status === "Closed" ? "text-gray-800" : props.po_status === "Canceled" ? "text-red-700" : props.po_status === "Open" ? "text-blue-800" : "text-green-800"}`}
      >
        {props.po_status}
      </label>
    </div>
  );
  const poIdTemp = (props) => <div>{`P${props.po_id}`}</div>;

  const customersGrid = [
    {
      field: "po_id",
      template: poIdTemp,
      headerText: "PO #",
      minWidth: "110",
      width: "110",
      maxWidth: "120",
      textAlign: "right",
    },
    {
      field: "order_date",
      headerText: "Order Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "150",
      width: "155",
      maxWidth: "160",
      textAlign: "Center",
    },
    {
      field: "vendor",
      headerText: "Vendor",
      minWidth: "160",
      width: "220",
      maxWidth: "360",
      textAlign: "left",
    },
    {
      field: "vendor_invoice_no",
      headerText: "Vendor Inv#",
      minWidth: "170",
      width: "180",
      maxWidth: "200",
      textAlign: "center",
    },
    {
      field: "po_revision",
      headerText: "PO Revision",
      minWidth: "170",
      width: "180",
      maxWidth: "200",
      textAlign: "center",
    },
    {
      field: "po_status",
      headerText: "Status",
      template: PartGridactiveStatus,
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: `total_price`,
      headerText: "Total Amt",
      format: "C2",
      minWidth: "140",
      width: "145",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: "amount_paid",
      format: "C2",
      headerText: "Amt Paid",
      minWidth: "140",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
    {
      field: "amount_pending",
      format: "C2",
      headerText: "Amt Pend",
      minWidth: "140",
      width: "140",
      maxWidth: "150",
      textAlign: "right",
    },
  ];

  const handlestatusClick = async (event) => {
    event.preventDefault();
    if (order) {
      TimeoutUtility.resetTimeout();
      if (order.po_status === "Open") {
        if (
          !order.full_received &&
          !window.confirm(
            `Order is not completely Received!\nStill want to continue?`,
          )
        )
          return;
        if (
          order.amount_paid < order.total_price &&
          !window.confirm(`Order is not Paid in Full!\nStill want to continue?`)
        )
          return;
        try {
          const resp = await ClosePurchaseOrderAPi(order.po_id);
          if (resp.success)
            showSuccessToast("Success!", "Purchase Order Closed successfully.");
          else {
            showErrorToast(
              "Error!",
              "Failed to Close Purchase Order\n\n" + resp.message,
            );
            return;
          }
        } catch (err) {
          showErrorToast("Error!", "Failed to update Purchase order Status.");
        }
        window.location.reload();
      } else {
        showInfoToast("Info!", "Order is already Closed.");
        return;
      }
    } else showInfoToast("Info!", "Please select Purchase order!");
  };

  const handlePrintOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) {
      const resp = await PrintPurchaseOrderApi(order.po_id);
      if (!resp) showErrorToast("Error!", "Record not found!");
    } else showInfoToast("Info!", "Please select Order to print!");
  };

  const handleAddOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (companyG.company_id) {
      if (order && window.confirm(`Do you want to copy the selected Order?`))
        localStorage.setItem("copyPOrder", order.po_id);
      window.open(`/Purchase/AddPurchaseOrder`);
    } else showInfoToast("Info!", "Please select Company to proceed!");
  };

  const handleEditOrderClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) window.open(`/Purchase/EditPurchaseOrder/${order.po_id}`);
    else showInfoToast("Info!", "Please Select Order!");
  };

  // const handleTransferOrderClick = async (event) => {
  //   TimeoutUtility.resetTimeout();
  //   event.preventDefault();
  //   if (order) {
  //     if (order.any_received)
  //       showErrorToast(
  //         "Error!",
  //         "This Order is already received and therefore cannot be transfered to another store!",
  //       );
  //     else if (order.amount_paid > 0)
  //       showErrorToast(
  //         "Error!",
  //         "This Order has Amount Paid and therefore cannot be transfered to another store!",
  //       );
  //     else setIsDialogOpen(true);
  //   } else showInfoToast("Info!", "Please Select Order!");
  // };

  // const handleTransferOrderStore = async (store) => {
  //   TimeoutUtility.resetTimeout();
  //   if (!order) {
  //     showErrorToast("Error!", "Please select an order to transfer!");
  //     return;
  //   }
  //   if (!store || !store.value) {
  //     showErrorToast("Error!", "Please select a store to transfer the order!");
  //     return;
  //   }
  //   if (store.value === order.store_id) {
  //     showErrorToast(
  //       "Error!",
  //       "This Transfer Order cannot be processed as the selected store is the same as the original store!\n\nTry again after selecting a different store.",
  //     );
  //     return;
  //   }
  //   if (
  //     window.confirm(
  //       `Are you sure you want to transfer this Order to ${store.label}?`,
  //     )
  //   ) {
  //     try {
  //       const resp = await TransferPurchaseOrderAPi(order.po_id, store.value);
  //       if (resp.success) {
  //         showSuccessToast("Success!", "Order transfered successfully!");
  //         window.location.reload();
  //       } else
  //         showErrorToast("Error!", "Order failed to transfer: " + resp.message);
  //     } catch (error) {
  //       showErrorToast("Error!", "Order failed to transfer!");
  //     }
  //   }
  // };

  const handleReceiveClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (order) navigate(`/Purchase/Receive/${order.po_id}`);
    else showInfoToast("Info!", "Please Select Order!");
  };

  const handleViewReceiveClick = () => {
    TimeoutUtility.resetTimeout();
    if (order) navigate(`/Purchase/ViewReceiveLog/${order.po_id}`);
    else showInfoToast("Info!", "Please select Order!");
  };

  const handleViewPurchaseClick = () => {
    TimeoutUtility.resetTimeout();
    if (order)
      window.open(`/Purchase/ViewPurchaseOrder/${order.po_id}`, "_blank");
    else showInfoToast("Info!", "Please Select Purchase Order!");
  };

  const handleRowSelected = (args) => setOrder(args?.data || null);

  // useEffect(() => {
  //   async function fetchData() {
  //     await GetAllStores()
  //       .then((resp) => {
  //         const storeOpt = resp.data.map((item) => ({
  //           label: item.name,
  //           value: item.store_id,
  //         }));
  //         setStoreOptions(storeOpt || []);
  //       })
  //       .catch((err) => console.log(err.message));
  //   }
  //   fetchData();
  // }, []);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      let cmp_id = 0;
      if (companyG.company_id) cmp_id = companyG.company_id;
      const resp = await GetAllPurchaseByCompStorID(cmp_id, storeG.store_id);
      setAllOrders(resp.data || []);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        let cmp_id = 0;
        if (companyG.company_id) cmp_id = companyG.company_id;
        trackPromise(
          GetAllPurchaseByCompStorID(cmp_id, storeG.store_id)
            .then((result) => setAllOrders(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG, companyG]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Row>
        <Col xl={3} md={5}>
          <Header category="Orders" title="PURCHASE ORDERS" />
        </Col>
        <Col xl={6} md={5} className="text-center">
          <Header title={companyG.name} />
        </Col>
      </Row>
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(26) && (
            <Col md="auto p-0">
              <Button text="Add" onClick={handleAddOrderClick} />
            </Col>
          )}
          {userPermID.includes(27) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditOrderClick} />
              </Col>
              {/* <Col md="auto p-0">
                <Button text="Transfer PO" onClick={handleTransferOrderClick} />
              </Col> */}
              <Col md="auto p-0">
                <Button text="Close PO" onClick={handlestatusClick} />
              </Col>
            </>
          )}
          {userPermID.includes(26) && (
            <Col md="auto p-0">
              <Button text="Receive" onClick={handleReceiveClick} />
            </Col>
          )}
          {userPermID.includes(25) && (
            <>
              <Col md="auto p-0">
                <Button text="View Receive" onClick={handleViewReceiveClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Print" onClick={handlePrintOrderClick} />
              </Col>
            </>
          )}
        </Row>
        {/* <PopupSelectField
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onSelect={(store) => handleTransferOrderStore(store)}
          options={storeOptions}
        /> */}
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllOrders}
        cols={customersGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(25) && handleViewPurchaseClick}
        persistant={true}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Purchase;
